// extracted by mini-css-extract-plugin
export default {"tableActions":"TableActions_tableActions__C1nfo"};